import { t } from 'ttag'
import React from 'react'

// Basic activities
import { ReactComponent as FigureWalk } from '../assets/sf-symbols/figure.walk.svg'
import { ReactComponent as FigureWalkTreadmill } from '../assets/sf-symbols/figure.walk.treadmill.svg'
import { ReactComponent as FigureRun } from '../assets/sf-symbols/figure.run.svg'
import { ReactComponent as FigureOutdoorCycle } from '../assets/sf-symbols/figure.outdoor.cycle.svg'
import { ReactComponent as FigurePoolSwim } from '../assets/sf-symbols/figure.pool.swim.svg'
import { ReactComponent as FigureYoga } from '../assets/sf-symbols/figure.yoga.svg'

// Racquet sports
import { ReactComponent as FigureBadminton } from '../assets/sf-symbols/figure.badminton.svg'
import { ReactComponent as FigureTennis } from '../assets/sf-symbols/figure.tennis.svg'
import { ReactComponent as FigureTableTennis } from '../assets/sf-symbols/figure.table.tennis.svg'
import { ReactComponent as FigureRacquetball } from '../assets/sf-symbols/figure.racquetball.svg'
import { ReactComponent as FigureSquash } from '../assets/sf-symbols/figure.squash.svg'
import { ReactComponent as FigurePickleball } from '../assets/sf-symbols/figure.pickleball.svg'

// Fitness & Training
import { ReactComponent as FigureArchery } from '../assets/sf-symbols/figure.archery.svg'
import { ReactComponent as FigureBarre } from '../assets/sf-symbols/figure.barre.svg'
import { ReactComponent as FigureCrossTraining } from '../assets/sf-symbols/figure.cross.training.svg'
import { ReactComponent as FigureCoreTraining } from '../assets/sf-symbols/figure.core.training.svg'
import { ReactComponent as FigurePilates } from '../assets/sf-symbols/figure.pilates.svg'
import { ReactComponent as FigureStrengthTrainingTraditional } from '../assets/sf-symbols/figure.strengthtraining.traditional.svg'
import { ReactComponent as FigureStrengthTrainingFunctional } from '../assets/sf-symbols/figure.strengthtraining.functional.svg'
import { ReactComponent as FigureFlexibility } from '../assets/sf-symbols/figure.flexibility.svg'
import { ReactComponent as FigureTaichi } from '../assets/sf-symbols/figure.taichi.svg'
import { ReactComponent as FigureMindAndBody } from '../assets/sf-symbols/figure.mind.and.body.svg'
import { ReactComponent as FigureCooldown } from '../assets/sf-symbols/figure.cooldown.svg'
import { ReactComponent as Arrow2Squarepath } from '../assets/sf-symbols/arrow.2.squarepath.svg'

// Team Sports
import { ReactComponent as FigureBaseball } from '../assets/sf-symbols/figure.baseball.svg'
import { ReactComponent as FigureBasketball } from '../assets/sf-symbols/figure.basketball.svg'
import { ReactComponent as FigureCricket } from '../assets/sf-symbols/figure.cricket.svg'
import { ReactComponent as FigureAmericanFootball } from '../assets/sf-symbols/figure.american.football.svg'
import { ReactComponent as FigureAustralianFootball } from '../assets/sf-symbols/figure.australian.football.svg'
import { ReactComponent as FigureIndoorSoccer } from '../assets/sf-symbols/figure.indoor.soccer.svg'
import { ReactComponent as FigureOutdoorSoccer } from '../assets/sf-symbols/figure.outdoor.soccer.svg'
import { ReactComponent as FigureHandball } from '../assets/sf-symbols/figure.handball.svg'
import { ReactComponent as FigureHockey } from '../assets/sf-symbols/figure.hockey.svg'
import { ReactComponent as FigureLacrosse } from '../assets/sf-symbols/figure.lacrosse.svg'
import { ReactComponent as FigureRugby } from '../assets/sf-symbols/figure.rugby.svg'
import { ReactComponent as FigureSoftball } from '../assets/sf-symbols/figure.softball.svg'
import { ReactComponent as FigureVolleyball } from '../assets/sf-symbols/figure.volleyball.svg'
import { ReactComponent as FigureWaterpolo } from '../assets/sf-symbols/figure.waterpolo.svg'
import { ReactComponent as FigureWrestling } from '../assets/sf-symbols/figure.wrestling.svg'

// Combat Sports
import { ReactComponent as FigureBoxing } from '../assets/sf-symbols/figure.boxing.svg'
import { ReactComponent as FigureKickboxing } from '../assets/sf-symbols/figure.kickboxing.svg'
import { ReactComponent as FigureMartialArts } from '../assets/sf-symbols/figure.martial.arts.svg'
import { ReactComponent as FigureFencing } from '../assets/sf-symbols/figure.fencing.svg'

// Water Sports
import { ReactComponent as FigureOpenWaterSwim } from '../assets/sf-symbols/figure.open.water.swim.svg'
import { ReactComponent as FigureWaterFitness } from '../assets/sf-symbols/figure.water.fitness.svg'
import { ReactComponent as FigureSurfing } from '../assets/sf-symbols/figure.surfing.svg'
import { ReactComponent as FigureSailing } from '../assets/sf-symbols/figure.sailing.svg'
import { ReactComponent as FigureOutdoorRowing } from '../assets/sf-symbols/figure.outdoor.rowing.svg'
import { ReactComponent as FigureIndoorRowing } from '../assets/sf-symbols/figure.indoor.rowing.svg'

// Winter Sports
import { ReactComponent as FigureSkiingDownhill } from '../assets/sf-symbols/figure.skiing.downhill.svg'
import { ReactComponent as FigureSkiingCrosscountry } from '../assets/sf-symbols/figure.skiing.crosscountry.svg'
import { ReactComponent as FigureSnowboarding } from '../assets/sf-symbols/figure.snowboarding.svg'
import { ReactComponent as FigureIceSkating } from '../assets/sf-symbols/figure.ice.skating.svg'
import { ReactComponent as FigureCurling } from '../assets/sf-symbols/figure.curling.svg'

// Outdoor Activities
import { ReactComponent as FigureHiking } from '../assets/sf-symbols/figure.hiking.svg'
import { ReactComponent as FigureClimbing } from '../assets/sf-symbols/figure.climbing.svg'
import { ReactComponent as FigureGolf } from '../assets/sf-symbols/figure.golf.svg'
import { ReactComponent as FigureFishing } from '../assets/sf-symbols/figure.fishing.svg'
import { ReactComponent as FigureHunting } from '../assets/sf-symbols/figure.hunting.svg'
import { ReactComponent as FigureEquestrianSports } from '../assets/sf-symbols/figure.equestrian.sports.svg'

// Indoor Equipment
import { ReactComponent as FigureIndoorCycle } from '../assets/sf-symbols/figure.indoor.cycle.svg'
import { ReactComponent as FigureRunTreadmill } from '../assets/sf-symbols/figure.run.treadmill.svg'
import { ReactComponent as FigureElliptical } from '../assets/sf-symbols/figure.elliptical.svg'
import { ReactComponent as FigureStairStepper } from '../assets/sf-symbols/figure.stair.stepper.svg'

// Dance & Movement
import { ReactComponent as FigureDance } from '../assets/sf-symbols/figure.dance.svg'
import { ReactComponent as FigureSocialdance } from '../assets/sf-symbols/figure.socialdance.svg'
import { ReactComponent as FigureGymnastics } from '../assets/sf-symbols/figure.gymnastics.svg'

// Recreation
import { ReactComponent as FigureBowling } from '../assets/sf-symbols/figure.bowling.svg'
import { ReactComponent as FigurePlay } from '../assets/sf-symbols/figure.play.svg'
import { ReactComponent as FigureGaming } from '../assets/sf-symbols/gamecontroller.fill.svg'
import { ReactComponent as FigureDiscSports } from '../assets/sf-symbols/figure.disc.sports.svg'

// Accessibility
import { ReactComponent as FigureSkateboarding } from '../assets/sf-symbols/figure.skateboarding.svg'
import { ReactComponent as FigureRoll } from '../assets/sf-symbols/figure.roll.svg'
import { ReactComponent as FigureRollRunningpace } from '../assets/sf-symbols/figure.roll.runningpace.svg'

// High Intensity
import { ReactComponent as FigureHighintensityIntervaltraining } from '../assets/sf-symbols/figure.highintensity.intervaltraining.svg'
import { ReactComponent as FigureMixedCardio } from '../assets/sf-symbols/figure.mixed.cardio.svg'
import { ReactComponent as FigureJumprope } from '../assets/sf-symbols/figure.jumprope.svg'

// Track & Field
import { ReactComponent as FigureTrackAndField } from '../assets/sf-symbols/figure.track.and.field.svg'

/**
 * Interface for workout activity items
 * Each activity has a value (identifier), label (translated display name), and icon component
 * Some activities are hidden from the main list but still available for selection
 */
export interface WorkoutActivity {
  value: string
  label: string
  hideFromList?: boolean
  icon?: React.ComponentType<any>
}

/**
 * Get all available workout activities with translated labels
 * This function ensures translations are evaluated at runtime, not at module load time
 * Activities are organized by category with helpful comments explaining
 * platform compatibility and backwards compatibility notes
 */
export const getWorkoutActivities = (): WorkoutActivity[] => [
  // Individual Sports
  { value: 'archery', label: t`Archery`, icon: FigureArchery },
  { value: 'badminton', label: t`Badminton`, icon: FigureBadminton },
  { value: 'barre', label: t`Barre`, icon: FigureBarre },
  { value: 'baseball', label: t`Baseball`, icon: FigureBaseball },
  { value: 'basketball', label: t`Basketball`, icon: FigureBasketball },
  { value: 'bowling', label: t`Bowling`, icon: FigureBowling },
  { value: 'boxing', label: t`Boxing`, icon: FigureBoxing },
  { value: 'cricket', label: t`Cricket`, icon: FigureCricket },
  { value: 'curling', label: t`Curling`, icon: FigureCurling },
  { value: 'fencing', label: t`Fencing`, icon: FigureFencing },
  { value: 'fishing', label: t`Fishing`, icon: FigureFishing },
  { value: 'golf', label: t`Golf`, icon: FigureGolf },
  { value: 'gymnastics', label: t`Gymnastics`, icon: FigureGymnastics },
  { value: 'handball', label: t`Handball`, icon: FigureHandball },
  { value: 'hunting', label: t`Hunting`, icon: FigureHunting },
  { value: 'jump_rope', label: t`Jump Rope`, icon: FigureJumprope },
  { value: 'kickboxing', label: t`Kickboxing`, icon: FigureKickboxing },
  { value: 'lacrosse', label: t`Lacrosse`, icon: FigureLacrosse },
  { value: 'martial_arts', label: t`Martial Arts`, icon: FigureMartialArts },
  { value: 'pickleball', label: t`Pickleball`, icon: FigurePickleball },
  { value: 'racquetball', label: t`Racquetball`, icon: FigureRacquetball },
  { value: 'rock_climbing', label: t`Climbing`, icon: FigureClimbing },
  { value: 'rugby', label: t`Rugby`, icon: FigureRugby },
  { value: 'sailing', label: t`Sailing`, icon: FigureSailing },
  { value: 'scuba_diving', label: t`Scuba Diving`, icon: FigureOpenWaterSwim },
  { value: 'softball', label: t`Softball`, icon: FigureSoftball },
  { value: 'squash', label: t`Squash`, icon: FigureSquash },
  { value: 'surfing', label: t`Surfing`, icon: FigureSurfing },
  { value: 'table_tennis', label: t`Table Tennis`, icon: FigureTableTennis },
  { value: 'tai_chi', label: t`Tai Chi`, icon: FigureTaichi },
  { value: 'tennis', label: t`Tennis`, icon: FigureTennis },
  { value: 'track_and_field', label: t`Track & Field`, icon: FigureTrackAndField },
  { value: 'volleyball', label: t`Volleyball`, icon: FigureVolleyball },
  { value: 'water_polo', label: t`Water Polo`, icon: FigureWaterpolo },
  { value: 'wrestling', label: t`Wrestling`, icon: FigureWrestling },

  // Cycling Activities
  { value: 'biking', label: t`Cycling`, icon: FigureOutdoorCycle },
  { value: 'biking.stationary', label: t`Indoor Cycling`, icon: FigureIndoorCycle },
  { value: 'biking.outdoor', label: t`Outdoor Cycling`, icon: FigureOutdoorCycle },
  { value: 'indoor_cycling', label: t`Indoor Cycling`, icon: FigureIndoorCycle },
  { value: 'cycling', label: t`Outdoor Cycling`, icon: FigureOutdoorCycle },

  // Dance Activities
  { value: 'dancing', label: t`Dancing`, icon: FigureDance },
  { value: 'dancing.social', label: t`Social Dancing`, icon: FigureSocialdance },
  { value: 'dancing.cardio', label: t`Cardio Dancing`, icon: FigureDance },

  // Football/Soccer Activities
  // For cordova-plugin-health backwards compatibility
  { value: 'football.soccer', label: t`Soccer`, icon: FigureOutdoorSoccer },
  // For Apple Health (indoor/outdoor)
  { value: 'soccer.indoor', label: t`Indoor Soccer`, icon: FigureIndoorSoccer },
  { value: 'soccer.outdoor', label: t`Outdoor Soccer`, icon: FigureOutdoorSoccer },
  { value: 'football.american', label: t`American Football`, icon: FigureAmericanFootball },
  { value: 'football.australian', label: t`Australian Football`, icon: FigureAustralianFootball },

  // Hockey Activities
  // For cordova-plugin-health backwards compatibility
  { value: 'hockey.roller', label: t`Roller Hockey`, icon: FigureHockey },

  { value: 'hockey', label: t`Hockey`, icon: FigureHockey },
  // For Apple Health (indoor/outdoor)
  { value: 'hockey.indoor', label: t`Indoor Hockey`, icon: FigureHockey },
  { value: 'hockey.outdoor', label: t`Outdoor Hockey`, icon: FigureHockey },

  // Skating Activities
  // For cordova-plugin-health backwards compatibility
  { value: 'ice_skating', label: t`Ice Skating`, hideFromList: true, icon: FigureIceSkating },
  { value: 'skating', label: t`Skating`, icon: FigureIceSkating },
  // For Apple Health (indoor/outdoor)
  { value: 'skating.indoor', label: t`Indoor Skating`, icon: FigureIceSkating },
  { value: 'skating.outdoor', label: t`Outdoor Skating`, icon: FigureIceSkating },

  // Running Activities
  { value: 'running', label: t`Running`, icon: FigureRun },
  { value: 'running.treadmill', label: t`Indoor Running`, icon: FigureRunTreadmill },
  { value: 'running.outdoor', label: t`Outdoor Running`, icon: FigureRun },

  // Rowing Activities
  { value: 'rowing.machine', label: t`Indoor Rowing`, icon: FigureIndoorRowing },
  { value: 'rowing', label: t`Outdoor Rowing`, icon: FigureOutdoorRowing },

  // Skiing Activities
  { value: 'skiing', label: t`Skiing`, icon: FigureSkiingDownhill },
  { value: 'skiing.cross_country', label: t`Cross Country Skiing`, icon: FigureSkiingCrosscountry },
  { value: 'skiing.downhill', label: t`Downhill Skiing`, icon: FigureSkiingDownhill },

  // Swimming Activities
  { value: 'swimming', label: t`Swimming`, icon: FigurePoolSwim },
  { value: 'swimming.pool', label: t`Pool Swimming`, icon: FigurePoolSwim },
  { value: 'swimming.open_water', label: t`Open Water Swimming`, icon: FigureOpenWaterSwim },

  // Stair Activities
  { value: 'stair_climbing', label: t`Stairs`, icon: FigureStairStepper },
  { value: 'stair_climbing.machine', label: t`Stair Stepper`, icon: FigureStairStepper },

  // Strength Training Activities
  { value: 'strength_training', label: t`Traditional Strength Training`, icon: FigureStrengthTrainingTraditional },
  {
    value: 'strength_training.functional',
    label: t`Functional Strength Training`,
    icon: FigureStrengthTrainingFunctional,
  },

  // Wheelchair Activities
  { value: 'wheelchair', label: t`Wheelchair`, icon: FigureRoll },
  { value: 'wheelchair.walkpace', label: t`Walkpace Wheelchair`, icon: FigureRoll },
  { value: 'wheelchair.runpace', label: t`Runpace Wheelchair`, icon: FigureRollRunningpace },

  // Mind & Body Activities
  { value: 'meditation', label: t`Mind & Body`, icon: FigureMindAndBody },
  { value: 'yoga', label: t`Yoga`, icon: FigureYoga },
  { value: 'pilates', label: t`Pilates`, icon: FigurePilates },
  { value: 'stretching', label: t`Stretching`, icon: FigureFlexibility },
  { value: 'flexibility', label: t`Flexibility`, icon: FigureFlexibility },

  // Training Activities
  { value: 'cooldown', label: t`Cooldown`, icon: FigureCooldown },
  { value: 'core_training', label: t`Core Training`, icon: FigureCoreTraining },
  { value: 'crossfit', label: t`Cross Training`, icon: FigureCrossTraining },
  {
    value: 'interval_training.high_intensity',
    label: t`High Intensity Interval Training`,
    icon: FigureHighintensityIntervaltraining,
  },
  { value: 'mixed_metabolic_cardio', label: t`Mixed Cardio`, icon: FigureMixedCardio },
  { value: 'preparation_and_recovery', label: t`Preparation And Recovery`, icon: FigureCooldown },

  // Cardio Equipment
  { value: 'elliptical', label: t`Elliptical`, icon: FigureElliptical },

  // Outdoor Activities
  { value: 'hiking', label: t`Hiking`, icon: FigureHiking },
  { value: 'walking', label: t`Walking`, icon: FigureWalk },
  { value: 'walking.indoor', label: t`Indoor Walking`, icon: FigureWalkTreadmill },
  { value: 'walking.outdoor', label: t`Outdoor Walking`, icon: FigureWalk },

  // Winter Sports
  { value: 'snowboarding', label: t`Snowboarding`, icon: FigureSnowboarding },
  { value: 'snowshoeing', label: t`Snowshoeing`, icon: FigureSkiingCrosscountry },
  { value: 'snow_sports', label: t`Snow Sports`, icon: FigureSkiingDownhill },

  // Water Activities
  { value: 'water_fitness', label: t`Water Fitness`, icon: FigureWaterFitness },
  { value: 'water_sports', label: t`Water Sports`, icon: FigureWaterFitness },
  { value: 'underwater_diving', label: t`Underwater Diving`, icon: FigureOpenWaterSwim },

  // Equestrian Activities
  { value: 'horseback_riding', label: t`Equestrian Sports`, icon: FigureEquestrianSports },

  // Other Activities
  { value: 'multi_sport', label: t`Multi-Sport`, icon: FigureMixedCardio },
  // Not recordable in the app — transitions only exist as legs of synced multi-sport activities
  // (e.g. Garmin triathlons), so the entry stays for their label/icon but is hidden from the
  // record-activity picker.
  { value: 'transition', label: t`Transition`, hideFromList: true, icon: Arrow2Squarepath },
  { value: 'disc_sports', label: t`Disc Sports`, icon: FigureDiscSports },
  { value: 'fitness_gaming', label: t`Fitness Gaming`, icon: FigureGaming },
  { value: 'paddle_sports', label: t`Paddle Sports`, icon: FigureOutdoorRowing },
  { value: 'play', label: t`Play`, icon: FigurePlay },
  { value: 'weightlifting', label: t`Weightlifting`, icon: FigureStrengthTrainingTraditional },
  { value: 'other', label: t`Other`, icon: FigureMixedCardio },

  // Activities not supported in Apple Health, only in Health Connect
  // These are hidden from the main list but still available for selection
  { value: 'bootcamp', label: t`Bootcamp`, hideFromList: true, icon: FigureCrossTraining },
  { value: 'calisthenics', label: t`Calisthenics`, hideFromList: true, icon: FigureStrengthTrainingTraditional },
  { value: 'exercise_class', label: t`Exercise Class`, hideFromList: true, icon: FigureStrengthTrainingTraditional },
  { value: 'frisbee_disc', label: t`Frisbee Disc`, hideFromList: true, icon: FigureDiscSports },
  { value: 'guided_breathing', label: t`Guided Breathing`, hideFromList: true, icon: FigureMindAndBody },
  { value: 'paragliding', label: t`Paragliding`, hideFromList: true, icon: FigureSurfing },
  // Synced from Garmin (not recorded in-app). Distinct from pickleball but shares its icon.
  { value: 'paddleball', label: t`Paddleball`, hideFromList: true, icon: FigurePickleball },
]

/**
 * Get the translated label for a specific workout activity type
 * @param activityType - The activity type identifier
 * @returns The translated label for the activity, or a default label if not found
 */
export const getWorkoutLabel = (activityType: string | null): string => {
  return getWorkoutActivities().find((activity) => activity.value === activityType)?.label || t`Activity`
}

/**
 * Check if an activity has an icon available
 * @param activityValue - The activity value to check
 * @returns True if the activity has an icon, false otherwise
 */
export const hasActivityIcon = (activityValue: string): boolean => {
  const activity = getWorkoutActivities().find((activity) => activity.value === activityValue)
  return activity?.icon !== undefined
}

/**
 * Get the React component for an activity
 * @param activityValue - The activity value to get the icon for
 * @returns The React component for the activity icon, or null if not found
 */
export const getActivityIconComponent = (activityValue: string): React.ComponentType<any> | null => {
  const activity = getWorkoutActivities().find((activity) => activity.value === activityValue)
  // console.log(activity)
  return activity?.icon || null
}

/**
 * Get the complete activity object for a specific activity type
 * @param activityType - The activity type identifier
 * @returns The complete WorkoutActivity object, or null if not found
 */
export const getWorkoutActivity = (activityType: string | null): WorkoutActivity | null => {
  return getWorkoutActivities().find((activity) => activity.value === activityType) || null
}

/**
 * Backward compatibility export - use getWorkoutActivities() instead
 * @deprecated Use getWorkoutActivities() function for proper translation support
 */
export const workoutActivities = getWorkoutActivities()
